export const CHARGE_USER_REQUEST = 'CHARGE_USER_REQUEST';
export const CHARGE_USER_SUCCESS = 'CHARGE_USER_SUCCESS';
export const CHARGE_USER_FAILURE = 'CHARGE_USER_FAILURE';

export const CLEAR_CHARGED_USER_DATA = 'CLEAR_CHARGED_USER_DATA';